export default {
    pt: {
        header: {
            title: 'Sobre a Pilar',
            description: 'Líder em vendas no alto padrão de São Paulo, nascemos para mudar a lógica do mercado imobiliário brasileiro.'
        },
        sections: {
            ourHistory: {
                title: 'Nossa história',
                paragraphs: [
                    'Atuamos em um setor tradicionalmente ineficiente, onde a venda de um imóvel leva cerca de 16 meses para ser concretizada, em comparação a apenas 2 meses em mercados mais desenvolvidos, e resulta em uma experiência frustrante para compradores e vendedores. Embora diversas inovações tenham surgido nos últimos anos, nenhuma foi pensada para resolver a dor dos clientes mais exigentes do mercado de alto padrão.',
                    'Em 2021, ano de fundação da Pilar, identificamos que a chave para a transformação estava na valorização dos corretores profissionais e entrega de uma estrutura de ponta que liberasse tempo para que pudessem focar no que realmente importa: o relacionamento com os clientes e a conexão com outros profissionais do mercado.',
                    'Nossa abordagem vai além da tecnologia. Acreditamos que a verdadeira mudança só acontece com uma nova cultura de trabalho, onde os melhores profissionais atuam de forma colaborativa, alinhados aos interesses dos clientes. Nossa rede de especialistas tem acesso completo ao maior portfólio de alto padrão de São Paulo, o que permite maior rapidez e eficiência para conectar clientes e imóveis.'
                ]
            },
            results: {
                title: [
                    'Nossos resultados neste pouco tempo indicam que',
                    'estamos no caminho certo',
                    '.'
                ],
                vgv: {
                    title: [
                        'Mais de',
                        'R$ 2 Bi',
                        'em VGV*'
                    ],
                    description: 'Transacionados por nossos parceiros em 2024.',
                    note: '*Valor Geral de Vendas (VGV): Refere-se ao valor total de transações realizadas em um determinado período.'
                },
                highValueSales: {
                    title: [
                        'Venda de imóveis acima de',
                        'R$ 3 Mi'
                    ],
                    description: 'Participação nas vendas nos principais bairros de SP.',
                    areas: {
                        itaimBibi: 'no Itaim Bibi',
                        jardins: 'nos Jardins',
                        pinheiros: 'em Pinheiros'
                    }
                }
            },
            brokers: {
                title: [
                    'Mais de 600 corretores',
                    ' integrados à ',
                    'Rede Pilar.'
                ],
                cta: 'Quero ser um parceiro Pilar'
            },
            naturalEvolution: {
                title: 'uma evolução natural.',
                description: 'Com os corretores que lideram o alto padrão de São Paulo equipados com as melhores ferramentas e uma sólida cultura de parceria, o próximo passo foi oferecer uma experiência à altura de seus clientes.',
                cta: 'Buscar imóveis'
            },
            experience: {
                title: 'A experiência de compra e venda que faltava no mercado de alto padrão.',
                description: 'Imobiliárias têm visibilidade limitada e portfólios restritos, enquanto outros portais priorizam volume. O PilarHomes une um portfólio exclusivo à expertise de corretores especialistas.',
                features: {
                    portfolio: {
                        title: 'Maior portfólio de alto padrão em SP',
                        description: 'Acesso exclusivo a um portfólio robusto, construído por profissionais líderes no segmento.'
                    },
                    connection: {
                        title: 'Conexão direta com especialistas',
                        description: 'Corretores com acesso ao portfólio completo, garantindo um processo eficiente e personalizado.'
                    },
                    secureExperience: {
                        title: 'Experiência segura para o alto padrão',
                        description: 'Imóveis exclusivos de parceiros confiáveis, sem duplicações, para uma compra segura.'
                    }
                },
                cta: 'Buscar imóveis'
            }
        }
    }
}
